<template>
  <div class="wrapper">
    <div class="container-singlepage">
      <div class="singlepage-breadcrumb">
        <template v-if="isHopeCupSite">
          <DetailBreadcrumb
            separate-symbol="/"
            :display-home="false"
            category-name="Home"
            category-path="/hope-cup"
            :title="title"
          />
        </template>
        <template v-else>
          <DetailBreadcrumb
            separate-symbol="/"
            :display-home="true"
            :title="title"
          />
        </template>
      </div>
      <h1 class="title">
        {{ title }}
      </h1>
      <div class="content typo" v-html="content" />
    </div>
  </div>
</template>

<script>
import DetailBreadcrumb from 'components/common/DetailBreadcrumb/index.vue'

export default {
  components: {
    DetailBreadcrumb,
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    content: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isHopeCupSite: false, // 是否是希望杯站点
    }
  },
  mounted() {
    this.getsiteJumpUrl()
  },
  methods: {
    // 获取跳转链接
    getsiteJumpUrl() {
      const sessionSourceSite = window.sessionStorage.getItem('source_site') || ''
      this.isHopeCupSite = sessionSourceSite === 'hopecup'
    },
  },
}
</script>

<style lang="scss">

@import "assets/css/typo.scss";

.container-singlepage {
  margin: 0 auto;

  .singlepage-breadcrumb {
    padding: 25px 0;
  }

  .title {
    margin-bottom: 50px;
    font-size: 46px;
  }

  .content {
    margin-bottom: 120px;
  }
}
</style>
